import PUBTOOLS from '@/utils/pubtools';
import $httpREQUEST from '@/utils/request';
import printJS from 'print-js'; // 引入print-js
import { aesEncrypt,aesDecrypt,aesEncryptShort,aesDecryptShort } from '@/utils/crypto'; // 用于加密数据

export default {
  name: "outgoods",
  data() {
    return {
      printContent: '', // 存储打印文本
      userList: [],
      totalMaoWeight: '0.00', // 毛重总量
      totalJingWeight: '0.00', // 净重总量
      queryInfo: {
        query: '',
        typeOutgoods: '',
        startDate: '',
        endDate: '',
        pagenum: 1,
        pagesize: 5,
      },
      dateRange: [], // 出库时间范围 [startDate, endDate]
      total: 0,
      dialogVisible: false, // 统一控制对话框显示
      isEdit: false, // 标识：true=编辑，false=新增
      // 通用表单数据（合并原userInfo和updateUserInfo）
      formData: {
        _id: '0000',
        _openid: 'admin',
        factoryOutgoods: "",//厂家
        namePeopleSendOutgoods: "",//取货人
        orderOutgoodsTime: PUBTOOLS.formatDateToYmd(null, true),//订货时间，未启用
        priceOutgoods: 0,//单价
        priceOutgoodsSum: 0,//总价
        recordOutgoodsTIme: "",//记录时间
        sendOutgoodsNum: 0,//净重
        modelOutgoods: '',//型号
        sendOutgoodsTime: PUBTOOLS.formatDateToYmd(),//取货时间
        typeOutgoods: "紫铜",//类型
        unitOutgoods: "kg",//单位
        maoWeight: "",//毛重
        piWeight: "",//皮重
        zhouModel: "",//轴型
        someInfo: "",//备注
        numModelOutgoods: ""//根数
      },
      // 统一验证规则
      userInfoRules: {
        sendOutgoodsTime: [
          { required: true, message: '请选择出库时间', trigger: 'change' }
        ]
      },
    }
  },
  created() {
    this.getUserList()
  },
  watch: {
    // 监听单价/数量变化，自动计算总价（通用）
    "formData.priceOutgoods": {
      handler() {
        this.computeTotal();
      },
      immediate: true
    },
    "formData.sendOutgoodsNum": {
      handler() {
        this.computeTotal();
      },
      immediate: true
    },
    "formData.maoWeight": {
      handler() {
        this.computeWeight();
      },
      immediate: true
    },
    "formData.piWeight": {
      handler() {
        this.computeWeight();
      },
      immediate: true
    }
  },
  methods: {
    // 获取数据列表
    async getUserList() {
      const { data: res } = await $httpREQUEST.get('/api/outgoods/getdata', { params: PUBTOOLS.addParams(this.queryInfo) })
      if (res.status !== 0) return this.$message.error('获取数据失败')
      this.userList = res.userList
      this.total = res.total
      this.totalMaoWeight = res.totalMaoWeight || '0.00'
      this.totalJingWeight = res.totalJingWeight || '0.00'
    },
    // 分页相关（原有逻辑不变）
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getUserList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getUserList()
    },
    // 类型筛选变化
    handleTypeChange() {
      this.queryInfo.pagenum = 1
      this.getUserList()
    },
    // 出库时间范围变化
    handleDateRangeChange(val) {
      if (val && val.length === 2) {
        this.queryInfo.startDate = val[0]
        this.queryInfo.endDate = val[1]
      } else {
        this.queryInfo.startDate = ''
        this.queryInfo.endDate = ''
      }
      this.queryInfo.pagenum = 1
      this.getUserList()
    },
    // 重置搜索条件
    resetSearch() {
      this.queryInfo.query = ''
      this.queryInfo.typeOutgoods = ''
      this.queryInfo.startDate = ''
      this.queryInfo.endDate = ''
      this.dateRange = []
      this.queryInfo.pagenum = 1
      this.getUserList()
    },
    // ========== 封装通用方法 ==========
    // 重置表单数据（通用）
    resetForm() {
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
      // 重置表单默认值
      this.formData = {
        _id: '',
        _openid: '',
        factoryOutgoods: "",
        namePeopleSendOutgoods: "",
        orderOutgoodsTime: PUBTOOLS.formatDateToYmd(null, true),
        priceOutgoods: 0,
        priceOutgoodsSum: 0,
        recordOutgoodsTIme: "",
        sendOutgoodsNum: 0,
        modelOutgoods: '',
        sendOutgoodsTime: PUBTOOLS.formatDateToYmd(),
        typeOutgoods: "紫铜",
        unitOutgoods: "kg",
        maoWeight: 0,
        piWeight: 0,
        zhouModel: "",
        someInfo: "",
        numModelOutgoods: 0
      };
    },
    // 对话框关闭事件（通用）
    dialogClose() {
      this.resetForm();
    },
    // 打开新增对话框
    openAddDialog() {
      this.isEdit = false; // 标记为新增
      this.resetForm(); // 重置表单
      this.dialogVisible = true; // 显示对话框
    },
    // 打开编辑对话框（复用）
    openEditDialog(rowData) {
      this.isEdit = true; // 标记为编辑
      this.resetForm(); // 先重置，再赋值
      // 给表单赋值（原updateUser逻辑）
      this.formData = {
        _id: rowData._id,
        _openid: rowData._openid,
        sendOutgoodsNum: rowData.sendOutgoodsNum,
        modelOutgoods: rowData.modelOutgoods,
        sendOutgoodsTime: rowData.sendOutgoodsTime,
        factoryOutgoods: rowData.factoryOutgoods,
        orderOutgoodsTime: rowData.orderOutgoodsTime,
        priceOutgoods: rowData.priceOutgoods,
        priceOutgoodsSum: rowData.priceOutgoodsSum,
        recordOutgoodsTIme: rowData.recordOutgoodsTIme,
        namePeopleSendOutgoods: rowData.namePeopleSendOutgoods,
        typeOutgoods: rowData.typeOutgoods,
        unitOutgoods: rowData.unitOutgoods,
        maoWeight: rowData.maoWeight || "",
        piWeight: rowData.piWeight || "",
        zhouModel: rowData.zhouModel || "",
        someInfo: rowData.someInfo || "",
        numModelOutgoods: rowData.numModelOutgoods || ""
      };
      this.dialogVisible = true; // 显示对话框
    },
    // 提交表单（新增/编辑通用）- 修复参数默认值和打印逻辑
    async submitForm(isPrint = false) { // 修复：添加默认值false，避免undefined报错
      // 表单验证
      const valid = await this.$refs.formRef.validate().catch(() => false);
      if (!valid) return;
      try {
        if (this.isEdit) {
          // 编辑逻辑
          await $httpREQUEST.post('/api/editOutgoodsInfo', this.formData);
          this.$message.success('修改记录成功');
          // 修复：编辑模式也支持保存并打印
          if (isPrint) this.printSingleData(this.formData);
        } else {
          // 新增逻辑
          this.formData._id = new Date().getTime().toString();
          this.formData._openid = "admin";
          this.formData.recordOutgoodsTIme = PUBTOOLS.formatDateToYmd(null, true);
          await $httpREQUEST.post('/api/outgoods/register', this.formData);
          this.$message.success('添加记录成功');
          // 新增成功后自动打印
          if (isPrint) this.printSingleData(this.formData);
        }
        this.dialogVisible = false; // 关闭对话框
        await this.getUserList(); // 刷新列表
      } catch (err) {
        this.$message.error(this.isEdit ? '修改失败' : '添加失败');
        console.error(err);
      }
    },
    // 计算总价
    computeTotal() {
      const price = parseFloat(this.formData.priceOutgoods) || 0;
      const num = parseFloat(this.formData.sendOutgoodsNum) || 0;
      this.formData.priceOutgoodsSum = (price * num).toFixed(2);
    },
    // 计算净重
    computeWeight() {
      const maoWeight = parseFloat(this.formData.maoWeight) || 0;
      const piWeight = parseFloat(this.formData.piWeight) || 0;
      this.formData.sendOutgoodsNum = (maoWeight - piWeight).toFixed(2);
    },
    // 删除数据（原有逻辑不变）
    async deleteUser(_id) {
      const confirmResult = await this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err);
      if (confirmResult !== 'confirm') return this.$message.info('已取消删除');
      const { data: res } = await $httpREQUEST.delete('/api/delOutgoods', { params: PUBTOOLS.addParams({ _id: _id }) });
      if (res.status !== 0) return this.$message.error('删除失败');
      this.$message.success('删除成功');
      await this.getUserList();
    },
    // ========== 打印相关方法（修复笔误和逻辑） ==========
    /**
     * 构建打印文本内容（适配76mm针式打印机，42字符宽度）
     * @param {Object} data 单条出库数据
     * @returns {String} 格式化的打印文本
     */
    buildPrintContent(data) {
      const line = "---------------------------------";
      const title1 = "饶阳县華億‌金属线材有限公司".padStart(17).padEnd(42);
      const title2 = "出库记录单".padStart(15).padEnd(42);
      
      // 关键：用模板字符串直接拼接，避免多余空行
      let content = `${line}\n${title1}\n${title2}\n${line}\n` +
        `出库时间：${data.sendOutgoodsTime || '-'.padEnd(10)}\n` +
        `类    型：${data.typeOutgoods || '-'.padEnd(10)}\n` +
        `型    号：${data.modelOutgoods || '-'.padEnd(10)}\n` +
        `根    数：${data.numModelOutgoods || '-'.padEnd(10)}\n` +
        `毛    重：${data.maoWeight || '-'.padEnd(10)} 公斤\n` +
        `皮    重：${data.piWeight || '-'.padEnd(10)} 公斤\n` +
        `净    重：${data.sendOutgoodsNum || 0} 公斤\n` +
        `单    价：${data.priceOutgoods || 0} 元/公斤\n` +
        // `总    价：${(data.sendOutgoodsNum*data.priceOutgoods).toFixed(2) || 0} 元\n` +
        `总    价：${data.priceOutgoodsSum || 0} 元\n` +
        `厂    家：${data.factoryOutgoods || '-'.padEnd(10)}\n` +
        `取 货 人：${data.namePeopleSendOutgoods || '-'.padEnd(10)}\n` +
        `轴    型：${data.zhouModel || '-'.padEnd(10)}\n` +
        `备    注：${data.someInfo || '-'.padEnd(20)}\n` +
        `记录时间：${data.recordOutgoodsTIme || '-'.padEnd(10)}\n` +
        `打印时间：${PUBTOOLS.formatDateToYmd(null, true)}\n` +
        `${line}\n`+
        `我司专业生产0.07mm至300mm 低氧杆、无氧杆、紫铜丝、黄铜丝、铜包铜丝、编织丝，代加工束丝业务。\n`+
        `地址:河北省饶阳县邹村工业区81号\n`+
        `电话:18831883698/13784869183\n`+
        `微信:xuxinhua1968\n`+
        `${line}\n`;
      
      const codeInfo = content+this.makeAESdata(data)+`\n${line}`;

      // 最终清理：确保无首尾空行，换行符统一为 \n
      return codeInfo.trim().replace(/\n+/g, '\n');
    },
    /*生产加密数据*/
    makeAESdata(data) {
      if(!data) data = {};
      // 给每个字段加默认值，避免空值
      const fields = [
        data.sendOutgoodsTime || '',
        data.factoryOutgoods || '',
        data.modelOutgoods || '',
        data.numModelOutgoods || '',
        data.sendOutgoodsNum || '',
        data.priceOutgoods || '',
        data.priceOutgoodsSum || '',
        data.namePeopleSendOutgoods || ''
      ];
      return aesEncrypt(fields.join('/'));
    },
    /**
     * 单条数据打印（无预览直接打印）
     * @param {Object} data 出库数据对象
     */
    printSingleData(data) {
      if (!data) {
        this.$message.warning('无打印数据');
        return;
      }
      // 1. 生成打印文本（确保数据完整）
      this.printContent = this.buildPrintContent(data);
      // console.log('生成的打印文本：', this.printContent); // 调试：确认文本有值
      
      // 2. 强制刷新DOM，确保 printContent 渲染到 pre 标签
      this.$forceUpdate();
      
      // 3. 等待 DOM 完全更新后，再调用 print-js
      this.$nextTick(() => {
        // 调试：查看模板是否已渲染内容
        const printEl = document.querySelector('#print-template pre');
        console.log('模板渲染内容：', printEl?.innerText);
        
        printJS({
          printable: 'print-template',
          type: 'html',
          targetStyles: ['*'],
          scanStyles: true,
          // 关键样式：确保内容可见，适配76mm宽度
          style: `
            @page {
              size: 76mm auto;
              margin: 5mm;
              /* 强制打印分辨率/密度 */
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            #print-template {
              position: static !important;
              left: 0 !important;
              top: 0 !important;
              width: 76mm !important;
              height: auto !important;
              overflow: visible !important;
            }
            pre {
              /* 1. 改用打印机兼容的点阵/等宽字体，提升清晰度 */
              font-family: 'SimHei', 'Courier New', 'Monospace', '宋体' !important;
              /* 2. 字体稍放大，增强打印辨识度（按需调整） */
              font-size: 13px !important;
              /* 3. 优化行高，避免字符重叠/模糊 */
              line-height: 1.4 !important;
              /* 4. 强制文本不模糊、无缩放 */
              white-space: pre-wrap !important; /* 这行开启自动换行 */
              word-wrap: break-word !important; /* 自动换行 */
              letter-spacing: 0.5px !important; /* 字符间距微调，更清晰 */
              width: 100% !important;
              margin: 0 !important;
              padding: 0 !important;
              /* 5. 禁用文本抗锯齿（针式/热敏机更清晰） */
              -webkit-font-smoothing: none !important;
              font-smoothing: none !important;
            }
          `,
          showModal: false, // 保持预览模式，方便调试
          onPrintDialogOpen: () => {
            // 预览窗口打开后，恢复模板隐藏状态
            document.getElementById('print-template').style.position = 'absolute';
            document.getElementById('print-template').style.left = '-9999px';
          },
          onPrintDialogClose: () => {
            this.$message.success('打印指令已发送');
          },
          onError: (err) => {
            this.$message.error('打印失败：' + err);
            console.error('打印错误详情：', err);
          }
        });
      });
    },
    /**
     * 表格行打印按钮触发的打印方法
     * @param {Object} row 表格行数据
     */
    printTableData(row) {
      console.log('打印行数据：', row); // 新增：调试用，查看传递的行数据
      this.printSingleData(row);
    }
  }
}